import { render } from "./RegisterPageTable.vue?vue&type=template&id=d3d3a6c2"
import script from "./RegisterPageTable.vue?vue&type=script&lang=js"
export * from "./RegisterPageTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__